import { createSelector } from 'reselect'
import { queryClient } from '@tabeeb/services/queryClient'
import { AccountQueryKeys } from '@tabeeb/modules/account/requests'
import { NotificationTypeEnum } from '@tabeeb/contracts/microservices/swagger-notifications-service'

export const callNotificationsSelector = (state) => state.callNotification.notifications
export const isCallAcceptedSelector = (state) => state.callNotification.isCallAccepted

export const callNotificationSelector = createSelector(
  [callNotificationsSelector, (_, { sessionId }) => sessionId],
  (notifications, sessionId) => {
    return notifications.find((notification) => notification.sessionId === sessionId)
  }
)

export const getIsProfileWebCallRingNotificationEnabled = createSelector(
  [() => queryClient.getQueryData([AccountQueryKeys.notificationSettings])],
  (notificationSettings) => {
    return notificationSettings?.notificationCategories
      .map((category) => category.notificationSettings)
      .flat()
      .find((setting) => setting.type === NotificationTypeEnum.WebCallRingNotification)?.isEnabled
  }
)
